import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";

export const _fetchClientUsers = async (data) => {
  //for payload.
  let postData = {
    search: data.search,
    page: data.currentPage,
    contact_forename: data.userFirstName,
    contact_surname: data.userLastName,
    contact_email: data.userEmail,
    phone_number: data.userPhoneNo,
    direct_dial: data.userDirectdial,
    user_role: data.userRole,
    sortByColumn: data.sortByColumn,
    sortByOrder: data.sortByOrder,
  };

  const request = {
    endPoint: serviceRouteConstants.clientUsers,
    data: postData,
  };
  return await post(request);
};

export const _fetchClientRoleList = async (data) => {
  let postData = {
    search: data.search,
    page: data.currentPage,
    actionedById: data.actionedById,
    actionedByType: data.actionedByType,
    sortByColumn: data.sortByColumn,
    sortByOrder: data.sortByOrder,
  };
  const request = {
    endPoint: serviceRouteConstants.clientRoleList,
    data: postData,
  };
  return await post(request);
};

export const _fetchClientContactAllList = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.getAllClientContactData,
  };
  return await post(request);
};

export const _addClientUser = async (data, avatarFile) => {
  const formData = new FormData();
  formData.append("first_name", data.firstName || "");
  formData.append("last_name", data.lastName || "");
  formData.append("email", data.email || "");
  formData.append("phone", data.phoneNumber || "");
  formData.append("direct_dial", data.directDial || "");
  formData.append("role_id", data.role || "");
  if (avatarFile) {
    formData.append("profile_image", avatarFile);
  }

  const request = {
    endPoint: serviceRouteConstants.addClientUsers,
    data: formData,
  };
  return await post(request);
};

export const _updateClientContactPrimary = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.updateClientContactPrimary,
    data: data,
  };
  return await post(request);
};

export const _addClientRole = async (data) => {
  let postData = {
    role_name: data.roleName,
    role_description: data.roleDescription,
    allPermission: JSON.stringify(data.allPermission),
  };

  const request = {
    endPoint: serviceRouteConstants.clientRoleAdd,
    data: postData,
  };
  return await post(request);
};

export const _editClientRole = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.clientRoleEdit,
    data: data,
  };
  return await post(request);
};

export const _fetchClientUsersListCount = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.clientUserListCount,
    data: data,
  };
  return await post(request);
};

export const _fetchClientUsersRole = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.fetchNewUserRolesData,
    data: data,
  };
  return await post(request);
};

export const _fetchClientUsersEdit = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.fetchClientUserEdit,
    data: {
      client_user_id: data,
    },
  };
  return await post(request);
};

export const _deleteClientUser = async (data) => {
  let isSelectedAll = data.isSelectedAll;

  let postData = {
    isSelectedAll: data.isSelectedAll & 1,
  };
  if (isSelectedAll) {
    postData.ignoreIds = data.ignoreIds;
  } else {
    postData.client_user_id = data.clientUserId;
  }

  const request = {
    endPoint: serviceRouteConstants.deleteClientUser,
    data: postData,
  };
  return await post(request);
};

export const _deleteClientRole = async (data) => {
  let postData = {
    isSelectedAll: data.isSelectedAll & 1,
  };

  if (data.isSelectedAll) {
    postData.ignoreIds = data.ignoreIds;
  } else {
    postData.role_id = data.role_id;
  }

  const request = {
    endPoint: serviceRouteConstants.clientRoleDelete,
    data: postData,
  };
  return await post(request);
};

export const _updateClientUser = async (
  data,
  avatarFile,
  EditClientUserData,
) => {
  const formData = new FormData();
  formData.append("client_user_id", EditClientUserData.client_user_id || "");
  formData.append("first_name", data.firstName || "");
  formData.append("last_name", data.lastName || "");
  formData.append("phone", data.phoneNumber || "");
  formData.append("direct_dial", data.directDial || "");
  formData.append("role_id", data.role || "");
  if (avatarFile) {
    formData.append("profile_image", avatarFile);
  }

  const request = {
    endPoint: serviceRouteConstants.updateClientUser,
    data: formData,
  };
  return await post(request);
};

//update roles data
export const _updateClientRoles = async (data) => {
  let postData = {
    role_id: data.roleId,
    role_name: data.roleName,
    role_description: data.roleDescription,
    allPermission: JSON.stringify(data.allPermission),
  };

  const request = {
    endPoint: serviceRouteConstants.updateClientRoles,
    data: postData,
  };
  return await post(request);
};

// resendEmailToClientUsers

export const _resendEmailToClientUsers = async (data) => {
  const { client_user_id, isSelectedAll, ignoreIds } = data;
  const postData = {
    client_user_id: client_user_id,
    isSelectedAll: isSelectedAll,
    ignoreIds: ignoreIds,
  };
  // return;
  const request = {
    endPoint: serviceRouteConstants?.resendEmailToClientUsers,
    data: postData,
  };
  return await post(request);
};
